// extracted by mini-css-extract-plugin
export default {"text":"empty-list_text__tXLrs"};